const jobAdUrl = (jobAd) => {
  return `/annonces/${jobAd.slug}`
}

const articleUrl = (article) => {
  if (!article) return ''
  if (!article.attributes) article = { attributes: article }
  return article.attributes.autoRoute
}

const tagUrl = (tagAutoRoute) => {
  return `${tagAutoRoute}`
}

const categoryUrl = (autoPath) => {
  return `/${autoPath}`
}

const sectorUrl = (slug) => {
  return `/secteurs/${slug}`
}

module.exports = {
  jobAdUrl,
  articleUrl,
  tagUrl,
  sectorUrl,
  categoryUrl,
}
